import { utcTime } from './urls';

type UtcTimeResponse = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
};

export async function fetchUtcTime(): Promise<UtcTimeResponse> {
  const response = await fetch(utcTime, {
    method: 'GET',
    headers: {
      tenant: process.env.REACT_APP_TENANT_ID || '',
    },
  });

  return response.json();
}
